import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import services from '../data/services';

const ServiceCard = ({ className, limit }) => {
  const { t } = useTranslation();
  const displayedServices = limit ? services.slice(0, limit) : services;

  return (
    <>
      {displayedServices.map((service) => {
        const title = t(`sections.ServiceCard.services.${service.translationKey}.title`);
        const text = t(`sections.ServiceCard.services.${service.translationKey}.text`);
        
        return (
          <div className={className} key={service.id}>
            <div className="service-card" data-cue="slideInUp">
              <div className="box-icon">
                <img src={service.icon} alt={title} />
              </div>
              <h3 className="box-title">
                <Link to={service.detailsLink}>{title}</Link>
              </h3>
              <p className="box-text">{text}</p>
              <Link to={service.detailsLink} className="link-btn style-gradient">
                {t('sections.ServiceCard.read_more', 'Read More')}<i className="far fa-long-arrow-right ms-2"></i>
              </Link>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ServiceCard;